export const DIGITAL_SFID = {
    id: '0',
    fullName: 'Digital Channel User',
    externalReference: {
        externalReferenceType: 'SFID',
        name: '50000000'
    }
};

export const LOGGED_USER_ENTITLEMENTS = ['OPEN_SUBSCRIPTION', 'OPEN_MANAGE_SERVICES'];
export const ANON_USER_ENTITLEMENTS = ['OPEN_SUBSCRIPTION'];
